var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"cancel_feature_list"},_vm._l((_vm.shuffledFeatures),function(feature){return _c('li',[_vm._v(_vm._s(feature))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }